const AuthType = {
    login: 'login',
    signup: 'signup',
};

export { AuthType };
